import { combineReducers } from 'redux';
import AggregatedData from '../common/store/aggregatedData/reducer';
import CompaniesManagement from '../common/store/company/reducer';
import CSVData from '../common/store/csvData/reducer';
import DepartmentsManagement from '../common/store/department/reducer';
import Gateways from '../common/store/gateways/reducer';
import GroupsManagement from '../common/store/group/reducer';
import GroupDevicesManagement from '../common/store/groupDevices/reducer';
import GroupStoresManagement from '../common/store/groupStores/reducer';
import HistoryData from '../common/store/historyData/reducer';
import LastSequence from '../common/store/lastSequence/reducer';
import LatestData from '../common/store/latestData/reducer';
import LoggersManagement from '../common/store/logger/reducer';
import MissingData from '../common/store/missingData/reducer';
import MultiGraph from '../common/store/multiGraph/reducer';
import RealtimeData from '../common/store/realtimeData/reducers';
import ReceiversManagement from '../common/store/receiver/reducer';
import StoresManagement from '../common/store/store/reducer';
import Theme from '../common/store/theme/reducer';
import TrendGraph from '../common/store/trendGraph/reducer';
import UnitsChannels from '../common/store/unitsChannels/reducer';
import User from '../common/store/user/reducers';
import Version from '../common/store/version/reducer';
import Dashboard from '../views/data/dashboard/reducer';
import GPSDashboard from '../views/data/gps-dashboard/reduxStore/reducer';
import LastData from '../views/data/last-data/reducer';
import ResetPassword from '../views/public/forgot-password/reduxStore/reducer';
import Login from '../views/public/login/reducer';
import ActivateUser from '../views/public/register/reduxStore/reducer';
import AlarmEmailRouting from '../views/settings/alarm-email-routing/reduxStore/reducer';
import ChannelSettings from '../views/settings/channel-settings/reducer';
import HealthMonitorSettings from '../views/settings/health-monitor/reduxStore/reducer';
import UsersManagement from '../views/users/reduxStore/reducer';
import ApiKeysManagement from '../views/api-keys/reduxStore/reducer';

import { loginActions } from 'src/views/public/login/actions';
/*
 * Combines all the existing reducers from /common/store/... and /views/...
 */
const reducers = combineReducers({
  Login,
  ResetPassword,
  ActivateUser,
  Dashboard,
  GPSDashboard,
  LastData,
  User,
  ChannelSettings,
  AggregatedData,
  RealtimeData,
  Gateways,
  UnitsChannels,
  LatestData,
  UsersManagement,
  GroupsManagement,
  GroupDevicesManagement,
  GroupStoresManagement,
  ReceiversManagement,
  LoggersManagement,
  CompaniesManagement,
  StoresManagement,
  DepartmentsManagement,
  Theme,
  LastSequence,
  HistoryData,
  CSVData,
  MissingData,
  MultiGraph,
  TrendGraph,
  Version,
  ApiKeysManagement,
  HealthMonitorSettings,
  AlarmEmailRouting,
});

const rootReducer = (state, action) => {
  // Clear all data in redux store to initial.
  if (action.type === loginActions.LOGOUT_SUCCESS) state = undefined;
  return reducers(state, action);
};

export default rootReducer;
